import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/edit-promotion-controller';
import { Spinner } from 'components/design';
import { PromotionForm } from '../components/promotion-form';

export const EditPromotionRoute = () => {
    const {
        formData,
        places,
        products,
        placeIds,
        dataChanged,
        onSubmit,
        onCancel,
        onChange,
        isLoading,
        isEditPromotionLoading,
        errors,
        isAdmin,
        placeId,
        productConfigData,
        handlePlaceIdsSelectChange,
        handleProductSelectChange,
        handleProductConfigPriceChange,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <PromotionForm
                    formData={formData}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onChange={onChange}
                    isSaveLoading={isEditPromotionLoading}
                    errors={errors}
                    disableSubmit={!dataChanged}
                    isAdmin={isAdmin}
                    placeId={placeId}
                    places={places}
                    products={products}
                    placeIds={placeIds}
                    onPlaceIdsSelectChange={handlePlaceIdsSelectChange}
                    onProductSelectChange={handleProductSelectChange}
                    productConfigData={productConfigData}
                    onConfigPriceChange={handleProductConfigPriceChange}
                    isEdit={true}
                />
            )}
        </OWContainer>
    );
};
